import styled from 'styled-components'

export const Button = styled.button`
  padding: 20px;
  width: 100%;
  background-color: ${prop => prop.color || 'GREY'};

  border-radius: 8px;
  border: ${prop => prop.border || 'none'};
  text-transform: uppercase;
  cursor: pointer;

  &[disabled] {
    opacity: 0.3;
    cursor: not-allowed;
  }
`
